module.exports = __webpack_public_path__ + "static/media/wordpress.cfda3310.svg";